import React from 'react';

import styles from './Covered.module.scss';

interface IProps {
  coverImage: string;
  title: string;
  date: string;
  link: string;
  width?: number;
  height?: number;
}

function CoveredPdfCard(props: IProps) {
  const { coverImage, link, title, date, width = 500, height = 679 } = props;

  /** 图片加载失败时上报 OWL 错误 */
  const handleImageError = () => {
    window.owl &&
      window.owl(
        'addError',
        {
          name: 'pdf图片加载失败',
          msg: `coverImage load failed: ${coverImage}`,
        },
        {
          category: 'customError',
          level: 'error',
          combo: true,
        },
      );
  };

  return (
    <a href={link} target="_blank" rel="noreferrer" className={styles.container}>
      <picture className={styles.image}>
        <img alt="" src={coverImage} height={height} width={width} onError={handleImageError} />
      </picture>

      <h6 className={styles.title}>{title}</h6>
      <span className={styles.date}>{date}</span>
    </a>
  );
}

export { CoveredPdfCard };
